import script from "./clinic-reception.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-reception.vue?vue&type=script&setup=true&lang=js"

import "./clinic-reception.vue?vue&type=style&index=0&id=7688b037&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7688b037"]])

export default __exports__